import { createFileRoute } from '@tanstack/react-router'

import EditKepPage from '@/components/pages/backoffice/_klb-petani/_kep/_$kepId/_edit/containers/EditKepPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/kep/$kepId/edit/'
)({
  component: EditKepPage
})
